import "../assets/index-4e03d941.css";
import l from "./NcActions.mjs";
import c from "./NcCounterBubble.mjs";
import r from "./NcVNodes.mjs";
import { t as u } from "../chunks/l10n-1b905a9a.mjs";
import { n as d } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const h = {
  name: "NcListItem",
  components: {
    NcActions: l,
    NcCounterBubble: c,
    NcVNodes: r
  },
  props: {
    /**
     * The details text displayed in the upper right part of the component
     */
    details: {
      type: String,
      default: ""
    },
    /**
     * Name (first line of text)
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Pass in `true` if you want the matching behavior to
     * be non-inclusive: https://router.vuejs.org/api/#exact
     */
    exact: {
      type: Boolean,
      default: !1
    },
    /**
     * The route for the router link.
     */
    to: {
      type: [String, Object],
      default: null
    },
    /**
     * The value for the external link
     */
    href: {
      type: String,
      default: "#"
    },
    /**
     * Id for the `<a>` element
     */
    anchorId: {
      type: String,
      default: ""
    },
    /**
     * Make subname bold
     */
    bold: {
      type: Boolean,
      default: !1
    },
    /**
     * Show the NcListItem in compact design
     */
    compact: {
      type: Boolean,
      default: !1
    },
    /**
     * Toggle the active state of the component
     */
    active: {
      type: Boolean,
      default: !1
    },
    /**
     * Aria label for the wrapper element
     */
    linkAriaLabel: {
      type: String,
      default: ""
    },
    /**
     * Aria label for the actions toggle
     */
    actionsAriaLabel: {
      type: String,
      default: ""
    },
    /**
     * If different from 0 this component will display the
     * NcCounterBubble component
     */
    counterNumber: {
      type: [Number, String],
      default: 0
    },
    /**
     * Outlined or highlighted state of the counter
     */
    counterType: {
      type: String,
      default: "",
      validator(i) {
        return ["highlighted", "outlined", ""].indexOf(i) !== -1;
      }
    },
    /**
     * To be used only when the elements in the actions menu are very important
     */
    forceDisplayActions: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "update:menuOpen"
  ],
  data() {
    return {
      hovered: !1,
      focused: !1,
      hasActions: !1,
      hasSubname: !1,
      displayActionsOnHoverFocus: !1,
      menuOpen: !1,
      hasIndicator: !1
    };
  },
  computed: {
    hasDetails() {
      return this.details !== "";
    },
    oneLine() {
      return !this.hasSubname && !this.showDetails;
    },
    showAdditionalElements() {
      return !this.displayActionsOnHoverFocus || this.forceDisplayActions;
    },
    showDetails() {
      return this.hasDetails && (!this.displayActionsOnHoverFocus || this.forceDisplayActions);
    },
    computedActionsAriaLabel() {
      return this.actionsAriaLabel || u('Actions for item with name "{name}"', { name: this.name });
    }
  },
  watch: {
    menuOpen(i) {
      !i && !this.hovered && (this.displayActionsOnHoverFocus = !1);
    }
  },
  mounted() {
    this.checkSlots();
  },
  updated() {
    this.checkSlots();
  },
  methods: {
    /**
     * Handle link click
     *
     * @param {PointerEvent} event - Native click event
     * @param {Function} [navigate] - VueRouter link's navigate if any
     * @param {string} [routerLinkHref] - VueRouter link's href
     */
    onClick(i, t, e) {
      this.$emit("click", i), !(i.metaKey || i.altKey || i.ctrlKey || i.shiftKey) && e && (t == null || t(i), i.preventDefault());
    },
    handleMouseover() {
      this.showActions(), this.hovered = !0;
    },
    showActions() {
      this.hasActions && (this.displayActionsOnHoverFocus = !0), this.hovered = !1;
    },
    hideActions() {
      this.displayActionsOnHoverFocus = !1;
    },
    /**
     * Show actions upon focus
     */
    handleFocus() {
      this.focused = !0, this.showActions();
    },
    handleBlur() {
      this.focused = !1;
    },
    /**
     * Hide the actions on mouseleave unless the menu is open
     */
    handleMouseleave() {
      this.menuOpen || (this.displayActionsOnHoverFocus = !1), this.hovered = !1;
    },
    /**
     * This method checks if the root element of the component is focused and
     * if that's the case it focuses the actions button if available
     *
     * @param {Event} e the keydown event
     */
    handleTab(i) {
      this.focused && this.hasActions ? (i.preventDefault(), this.$refs.actions.$refs.menuButton.$el.focus(), this.focused = !1) : this.displayActionsOnHoverFocus = !1;
    },
    handleActionsUpdateOpen(i) {
      this.menuOpen = i, this.$emit("update:menuOpen", i);
    },
    // Check if subname and actions slots are populated
    checkSlots() {
      this.hasActions !== !!this.$slots.actions && (this.hasActions = !!this.$slots.actions), this.hasSubname !== !!this.$slots.subname && (this.hasSubname = !!this.$slots.subname), this.hasIndicator !== !!this.$slots.indicator && (this.hasIndicator = !!this.$slots.indicator);
    }
  }
};
var p = function() {
  var t = this, e = t._self._c;
  return e(t.to ? "router-link" : "NcVNodes", { tag: "component", attrs: { custom: t.to ? !0 : null, to: t.to, exact: t.to ? t.exact : null }, scopedSlots: t._u([{ key: "default", fn: function({ href: n, navigate: o, isActive: a }) {
    return [e("li", { staticClass: "list-item__wrapper", class: { "list-item__wrapper--active": a || t.active } }, [e("a", { ref: "list-item", staticClass: "list-item", attrs: { id: t.anchorId, href: n || t.href, target: t.href === "#" ? void 0 : "_blank", rel: t.href === "#" ? void 0 : "noopener noreferrer", "aria-label": t.linkAriaLabel }, on: { mouseover: t.handleMouseover, mouseleave: t.handleMouseleave, focus: t.handleFocus, blur: t.handleBlur, keydown: [function(s) {
      return !s.type.indexOf("key") && t._k(s.keyCode, "tab", 9, s.key, "Tab") || s.ctrlKey || s.shiftKey || s.altKey || s.metaKey ? null : t.handleTab.apply(null, arguments);
    }, function(s) {
      return !s.type.indexOf("key") && t._k(s.keyCode, "esc", 27, s.key, ["Esc", "Escape"]) ? null : t.hideActions.apply(null, arguments);
    }], click: function(s) {
      return t.onClick(s, o, n);
    } } }, [e("div", { staticClass: "list-item-content__wrapper", class: { "list-item-content__wrapper--compact": t.compact } }, [t._t("icon"), e("div", { staticClass: "list-item-content" }, [e("div", { staticClass: "list-item-content__main", class: { "list-item-content__main--oneline": t.oneLine } }, [e("div", { staticClass: "line-one" }, [e("span", { staticClass: "line-one__name" }, [t._v(" " + t._s(t.name) + " ")]), t.showDetails ? e("span", { staticClass: "line-one__details" }, [t._v(" " + t._s(t.details) + " ")]) : t._e()]), e("div", { staticClass: "line-two", class: { "line-two--bold": t.bold } }, [t.hasSubname ? e("span", { staticClass: "line-two__subname" }, [t._t("subname")], 2) : t._e(), t.counterNumber != 0 || t.hasIndicator ? e("span", { directives: [{ name: "show", rawName: "v-show", value: t.showAdditionalElements, expression: "showAdditionalElements" }], staticClass: "line-two__additional_elements" }, [t.counterNumber != 0 ? e("NcCounterBubble", { staticClass: "line-two__counter", attrs: { active: a || t.active, type: t.counterType } }, [t._v(" " + t._s(t.counterNumber) + " ")]) : t._e(), t.hasIndicator ? e("span", { staticClass: "line-two__indicator" }, [t._t("indicator")], 2) : t._e()], 1) : t._e()])]), t.forceDisplayActions ? t._e() : e("div", { directives: [{ name: "show", rawName: "v-show", value: t.displayActionsOnHoverFocus, expression: "displayActionsOnHoverFocus" }], staticClass: "list-item-content__actions", on: { click: function(s) {
      s.preventDefault(), s.stopPropagation();
    } } }, [e("NcActions", { ref: "actions", attrs: { primary: a || t.active, "aria-label": t.computedActionsAriaLabel }, on: { "update:open": t.handleActionsUpdateOpen } }, [t._t("actions")], 2)], 1)]), t.forceDisplayActions ? e("div", { staticClass: "list-item-content__actions", on: { click: function(s) {
      s.preventDefault(), s.stopPropagation();
    } } }, [e("NcActions", { ref: "actions", attrs: { primary: a || t.active, "aria-label": t.computedActionsAriaLabel }, on: { "update:open": t.handleActionsUpdateOpen } }, [t._t("actions")], 2)], 1) : t._e()], 2), t.$slots.extra ? e("div", { staticClass: "list-item__extra" }, [t._t("extra")], 2) : t._e()])])];
  } }], null, !0) });
}, f = [], m = /* @__PURE__ */ d(
  h,
  p,
  f,
  !1,
  null,
  "4d352b50",
  null,
  null
);
const k = m.exports;
export {
  k as default
};
